export default __webpack_public_path__ + "dac40209f26247a870dc37deb0c2f7da.svg";